import type { Strings } from '../../i18n/strings';
import type { NavItem } from '../../ui/StaffShell';

export type HeadTab = 'overview' | 'results' | 'whatworks' | 'staff' | 'calendar' | 'report' | 'council' | 'playbook' | 'compliance' | 'settings' | 'questions' | 'activity' | 'me';

// The head of school's menu, the same on every page they reach, including
// their own check-in (B7: the menu used to collapse on /me/checkin).
export function headNav(t: Strings, tab: HeadTab): NavItem[] {
  return [
    { icon: '🏠', label: t['hs.navOverview'], href: '/school', active: tab === 'overview' },
    { icon: '🏫', label: t['hs.navResults'], href: '/school/results', active: tab === 'results' },
    { icon: '💡', label: t['r3.nav.whatWorks'], href: '/school/what-works', active: tab === 'whatworks' },
    { icon: '🧑‍🏫', label: t['r3.nav.staff'], href: '/school/staff', active: tab === 'staff' },
    { icon: '📅', label: t['r3.nav.calendar'], href: '/school/calendar', active: tab === 'calendar' },
    { icon: '📄', label: t['h2.navReport'], href: '/school/report', active: tab === 'report' },
    { icon: '🗳️', label: t['h2.navCouncil'], href: '/school/council', active: tab === 'council' },
    { icon: '📘', label: t['h2.navPlaybook'], href: '/school/playbook', active: tab === 'playbook' },
    { icon: '📁', label: t['h2.navCompliance'], href: '/school/compliance', active: tab === 'compliance' },
    { icon: '⚙️', label: t['hs.navSettings'], href: '/school/settings', active: tab === 'settings' },
    { icon: '❓', label: t['hs.navQuestions'], href: '/school/questions', active: tab === 'questions' },
    { icon: '🧾', label: t['hs.navActivity'], href: '/school/activity', active: tab === 'activity' },
    { icon: '🫶', label: t['r3.me.nav'], href: '/me/checkin', active: tab === 'me' },
  ];
}
